export const business = {
  name: "Champion Automotive Machine Shop",
  phone: "(334) 393-5401",
  phoneHref: "tel:+13343935401",
  email: "championauto526@gmail.com",
  address: "522b Glover Ave",
  city: "Enterprise",
  state: "AL",
  zip: "36330",
  since: "2016",
  hours: "Mon–Fri 8:00am – 5:00pm",
  lunchBreak: "Lunch break 12:00pm – 1:00pm",
  owner: "John Potts",
  areaServed: "Enterprise, Alabama and the Wiregrass region",
  siteUrl: "https://championautomotivemachineshop.net",
  latitude: 31.3194632,
  longitude: -85.8451126,
  googleReviewsUrl: "https://share.google/lndcAqBWMNUdwNrna",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Champion+Automotive+Machine+Shop+522b+Glover+Ave+Enterprise+AL+36330",
  googleMapsEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3408.4311784376664!2d-85.8451126!3d31.31946319999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88926f24cf7064e3%3A0x75a47e61b473db8d!2sChampion%20Automotive%20Machine%20Shop!5e0!3m2!1sen!2sus!4v1785784527316!5m2!1sen!2sus",
};

export const engineTypes = [
  "Automotive engines",
  "Light and large truck engines",
  "Diesel engines",
  "Industrial engines",
  "Farm tractor engines",
  "Motorcycle engines",
];

export const shopFloor = [
  {
    title: "Seat & Valve Guide Machine",
    machine: "TCM-25 Peterson",
    tag: "Cylinder heads",
    body: "Valve seat cutting and guide work for gas and diesel heads. This is the machine that puts a true seat on the valve so the head seals, breathes, and lasts.",
  },
  {
    title: "Rotating & Balancing Machine",
    machine: "Shop balancer",
    tag: "Rotating assembly",
    body: "Crankshafts and rotating assemblies get balanced here so the engine runs smooth at speed — less vibration, longer bearing life, and a cleaner-feeling rebuild.",
  },
  {
    title: "Clevor Engine",
    machine: "Ford Cleveland + Windsor",
    tag: "In the shop",
    body: "Clevor builds on the floor — blue short blocks, aluminum Cleveland heads with Trick Flow hardware, gold rockers, and chamber CCing for exact volume. Custom engine work measured and machined the same careful way as every job that comes through the shop.",
  },
  {
    title: "Machine Lathe",
    machine: "LeBlond",
    tag: "Turning & facing",
    body: "Heavy-duty LeBlond lathe work for shafts, sleeves, bushings, and precision turning — the kind of custom machine work that keeps a rebuild moving when a part needs to be made right, not ordered.",
  },
  {
    title: "Cylinder Honing Machine",
    machine: "Winona Van Norman BE 3301 Auto Hone",
    tag: "Cylinder finish",
    body: "Vertical cylinder honing for the crosshatch finish pistons and rings need. Blocks go in the Winona Van Norman Auto Hone so every bore is round, straight, and ready to seal oil and hold compression.",
  },
  {
    title: "Magnaflux Machine",
    machine: "Magnetoscopio · Torino, Italy",
    tag: "Crack detection",
    body: "Magnetic particle inspection for crankshafts and other critical parts. Before a rebuild goes back together, this machine finds cracks you can't see by eye — so weak parts don't make it into a finished engine.",
  },
];

export const services = [
  {
    title: "Cylinder Boring",
    body: "Precision boring to restore true, round cylinders and correct wear before your rebuild.",
    details:
      "Worn, out-of-round, or tapered cylinders rob compression and shorten engine life. We bore blocks to a true, round finish so pistons and rings seat correctly — the foundation of a rebuild that holds power and oil control.",
  },
  {
    title: "Seat & Valve Guide Work",
    body: "Valve seat cutting and guide repair on the TCM-25 Peterson so heads seal and breathe correctly.",
    details:
      "Burned seats, worn guides, and poor valve geometry cost compression and oil control. We machine valve seats and guides on a TCM-25 Peterson so the valves close true, the head seals under heat, and the engine holds a clean idle and strong top end — gas or diesel.",
  },
  {
    title: "Cylinder Sleeving",
    body: "Save a cracked or scored block with a properly fitted sleeve instead of replacing it.",
    details:
      "A scored, cracked, or oversized cylinder doesn't always mean a new block. We install and machine sleeves to bring damaged cylinders back into spec, often saving engines other shops write off as scrap.",
  },
  {
    title: "Stroker Block Machining",
    body: "Clearance and machine work for stroker rotating assemblies and custom builds.",
    details:
      "Stroker builds need precise clearances for the crank, rods, and rotating assembly. We machine and clear the block so your stroker kit turns freely without rubbing, binding, or cutting corners on fitment.",
  },
  {
    title: "Line Boring & Honing",
    body: "Main bore alignment and cylinder honing on a Winona Van Norman Auto Hone so your crank spins straight and rings seat right.",
    details:
      "Misaligned main bores cause bearing wear, noise, and early failure. Line boring restores crankshaft alignment; cylinder honing on our Winona Van Norman BE 3301 Auto Hone finishes the bores with the crosshatch pattern pistons and rings need for oil control and compression under load.",
  },
  {
    title: "Block & Head Surfacing",
    body: "Flat, clean deck and head surfaces for a gasket seal that holds under real load.",
    details:
      "Warped or uneven decks and heads leak coolant, oil, and compression. We surface blocks and cylinder heads flat and clean so head gaskets seal under heat and pressure — critical for both street and diesel work.",
  },
  {
    title: "Rotating Assembly Balancing",
    body: "Balance cranks and rotating assemblies so the engine runs smooth and bearings live longer.",
    details:
      "An out-of-balance crank, flywheel, or rotating assembly shakes the block apart over time. We balance rotating assemblies so the engine runs smooth at speed — less vibration through the chassis, less load on mains and rods, and a rebuild that feels finished.",
  },
  {
    title: "Lathe Work",
    body: "Turning, facing, and custom machining on a LeBlond metal lathe for shafts, sleeves, and bushings.",
    details:
      "When a rebuild needs a sleeve turned, a shaft faced, or a bushing made to fit, the LeBlond lathe is where that work happens. Precision turning and facing keep custom parts in-house so your job doesn't wait on a catalog part that almost fits.",
  },
  {
    title: "Magnaflux / Crack Detection",
    body: "Magnetic particle inspection on crankshafts and critical parts before they go back in the engine.",
    details:
      "A cracked crank can look fine until it fails under load. We magnaflux crankshafts and other critical parts on our Magnetoscopio inspection machine so hidden cracks show up before the engine is assembled — not after it's back in the vehicle.",
  },
  {
    title: "Diesel & Heavy Duty",
    body: "Machining for diesel truck, industrial, and farm tractors.",
    details:
      "Heavy-duty and diesel engines see hard use in trucks, equipment, and farm tractors. We machine these blocks and heads with the same precision as automotive work — built for torque, hours, and reliability in the field.",
  },
];

export const faqs = [
  {
    q: "What kinds of engines do you machine?",
    a: "Automotive, light and large truck, diesel, industrial, farm tractor and motorcycle engines. We are a machine shop — we do engine machine work only, not oil changes, tires or general repair.",
  },
  {
    q: "Do you guarantee your machine work?",
    a: "Yes. All machine work is guaranteed to your satisfaction. If something isn't right, we make it right.",
  },
  {
    q: "How long have you been in business?",
    a: `We opened our doors on January 1, ${business.since} and bring over 10 years of hands-on engine machining experience to every job.`,
  },
  {
    q: "Can you save a block that another shop said was scrap?",
    a: "Often, yes. Sleeving, line boring and surfacing can bring a worn or damaged block back into spec. Bring it by and we'll give you an honest assessment.",
  },
  {
    q: "How fast do you respond?",
    a: "Calling is the fastest way to reach us. If we're on a machine and miss your call, we return it within 24 business hours.",
  },
  {
    q: "Do you work with shops and businesses, not just individuals?",
    a: "Yes — we machine for homeowners and DIY builders, repair shops, fleets, businesses and tractor companies.",
  },
];

export const reviews = [
  {
    name: "Local Customer",
    text: "John does great work and takes the time to explain exactly what my block needed. Engine runs stronger than it did new.",
  },
  {
    name: "Repair Shop Owner",
    text: "Straight answers, fair pricing and the machine work comes back right the first time. We send all our block work here.",
  },
  {
    name: "Tractor Owner",
    text: "Had a tractor engine everyone else wanted to replace. Champion sleeved it and it's back in the field.",
  },
];
